import React from 'react';
import classNames from 'classnames';
import PropTypes from "prop-types";
import Tab from "./Tab";

class Tabs extends React.Component {

	static propTypes = {
        currentTab: PropTypes.any,
        defaultTab: PropTypes.any,
        onTabChange: PropTypes.func,
		disabled: PropTypes.bool,
		tab: PropTypes.func,
        className: PropTypes.any,
        extraTabsLocation: PropTypes.oneOf(["before", "after"]),
        extraTabs: PropTypes.any,
        renderAll: PropTypes.bool
	};

    constructor(props) {
        super(props);
        this.state = {
            currentTab: props.currentTab !== undefined ? props.currentTab : props.defaultTab
        };
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (prevProps.currentTab !== this.props.currentTab) {
            this.setState({currentTab: this.props.currentTab});
        }
        if (prevProps.defaultTab !== this.props.defaultTab) {
            this.setState({
                defaultTab: this.props.defaultTab,
                currentTab: this.props.currentTab !== undefined ? this.props.currentTab : this.props.defaultTab
            });
        }
    }

    setActiveTab = async (e, currentTab) => {
        e && e.preventDefault();
        if (this.props.disabled) {
            return;
        }
        if (currentTab === this.state.currentTab) return;
        if (this.props.onTabChange) {
            try {
                await this.props.onTabChange(currentTab);
                this.setState({currentTab});
            } catch (e) {
                throw e;
            }
        } else {
            this.setState({currentTab});
        }
    }

    render() {
        const currentTab = this.state.currentTab;
        const CurrentTab = this.props.renderAll ? null : React.Children.toArray(this.props.children).find(child => ((child || {}).props || {}).tabName === currentTab);
        return (
            <div className={classNames("nav-tabs-custom", this.props.className)}>
                <ul className={classNames("nav", {"nav-tabs": !this.props.pills, "nav-pills": !!this.props.pills, "nav-fill": !!this.props.fill})}>
                    {this.props.extraTabsLocation === "before" && this.props.extraTabs}
                    {React.Children.map(this.props.children, child => {
                            if(child === null) return child;
                            const tabName = ((child || {}).props || {}).tabName;
                            let TabComponent = Tab;
                            if (this.props.tab) {
                                if (this.props.tab instanceof Function) {
                                    return this.props.tab({
                                        currentTab: currentTab, tabLabel: child.props.tabLabel, tabName: tabName, onClick: this.setActiveTab
                                    });
                                } else {
                                    TabComponent = this.props.tab;
                                }
                            }
                            return (
                                <TabComponent currentTab={currentTab} tabLabel={child.props.tabLabel} disabled={child.props.disabled} tabName={tabName} onClick={this.setActiveTab}>
                                    {child.props.tabLabel}
                                </TabComponent>
                            );
                        }
                    )}
                    {this.props.extraTabsLocation !== "before" && this.props.extraTabs}
                </ul>
                {this.props.renderAll ? React.Children.toArray(this.props.children).map((Child, idx) => <Child.type key={idx} {...(Child || {}).props} active={((Child || {}).props || {}).tabName === currentTab} />) : (CurrentTab && <CurrentTab.type {...CurrentTab.props} active={true} />)}
            </div>
        );
    }
}

export default Tabs;